import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Brain, Layers, GraduationCap, Trophy, Bot, LineChart } from "lucide-react";
import Pricing from "@/components/landing/Pricing";
import About from "@/components/landing/About";

const features = [
  {
    title: "AI-Powered Flashcards",
    description: "Create and study with intelligent flashcards that adapt to your learning style",
    icon: Layers,
    color: "text-blue-500",
  },
  {
    title: "Smart Quiz Generation",
    description: "Take personalized quizzes generated by AI based on your study materials",
    icon: Brain,
    color: "text-green-500",
  },
  {
    title: "Mock Tests",
    description: "Practice with realistic mock tests that simulate exam conditions",
    icon: GraduationCap,
    color: "text-purple-500",
  },
  {
    title: "Progress Tracking",
    description: "Monitor your learning progress with detailed analytics and insights",
    icon: LineChart,
    color: "text-yellow-500",
  },
  {
    title: "AI Study Assistant",
    description: "Get help from our AI assistant for any questions or clarifications",
    icon: Bot,
    color: "text-pink-500",
  },
  {
    title: "Leaderboard",
    description: "Compete with others and track your ranking on the leaderboard",
    icon: Trophy,
    color: "text-orange-500",
  },
];

export default function Index() {
  const { currentUser } = useAuth();
  const navigate = useNavigate();

  return (
    <main>
      {/* Header with Auth Buttons - Removing duplicate buttons since they're in Navigation */}
      {/* Features Section */}
      <section className="py-20">
        <div className="container px-4 md:px-6">
          <div className="text-center">
            <h1 className="text-4xl font-bold tracking-tight sm:text-6xl mb-4">
              Welcome to Questly
            </h1>
            <p className="text-xl text-muted-foreground mb-16">
              Transform your learning experience with AI-powered tools
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {features.map((feature) => (
              <Card key={feature.title} className="transition-all hover:shadow-lg">
                <CardHeader>
                  <feature.icon className={`h-8 w-8 ${feature.color}`} />
                  <CardTitle className="mt-4">{feature.title}</CardTitle>
                  <CardDescription>{feature.description}</CardDescription>
                </CardHeader>
                <CardContent></CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section className="bg-muted/30">
        <Pricing />
      </section>

      {/* About Section */}
      <About />
    </main>
  );
}